import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=f57e6970&scoped=true"
import script from "./PointsHistory.vue?vue&type=script&lang=ts"
export * from "./PointsHistory.vue?vue&type=script&lang=ts"
import style0 from "./PointsHistory.vue?vue&type=style&index=0&id=f57e6970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57e6970",
  null
  
)

export default component.exports